import {
  BreakPointCondition,
  SliderModal,
  useBreakpointIf,
  HStack as NBHStack,
} from '@genial/components';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { StyleSheet, Dimensions } from 'react-native';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../routes/types';

import { OrderDetails } from './components/OrderDetails';

export const OrderHistoryModal = () => {
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'OrderHistoryModal'>>();

  const { goBack, canGoBack, navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const handleCloseDetails = () => {
    if (canGoBack()) {
      return goBack();
    }
    navigate('OrdersHistory');
  };

  if (!params?.item) {
    handleCloseDetails();
  }

  return (
    <SliderModal onDismiss={handleCloseDetails} width={isMobile || isTablet ? 1 : 0.9}>
      <NBHStack minHeight={'auto'} style={styles.view} overflowY="scroll">
        <OrderDetails item={params.item} handleCloseDetails={handleCloseDetails} />
      </NBHStack>
    </SliderModal>
  );
};

const styles = StyleSheet.create({
  view: {
    minHeight: Dimensions.get('window').height,
    maxHeight: Dimensions.get('window').height,
    backgroundColor: '#F9F9F9',
  },
});
